/** CoStar.Api.ConsumerUserData.ListingSettings.ListingSettingType */
export var ListingSettingType;
(function (ListingSettingType) {
    ListingSettingType[ListingSettingType["None"] = 0] = "None";
    ListingSettingType[ListingSettingType["DisableCascadeAmenities"] = 1] = "DisableCascadeAmenities";
    ListingSettingType[ListingSettingType["MediaGallery"] = 2] = "MediaGallery";
    ListingSettingType[ListingSettingType["PropertyLicenseNumber"] = 3] = "PropertyLicenseNumber";
    ListingSettingType[ListingSettingType["LocationLeasingOffice"] = 4] = "LocationLeasingOffice";
    ListingSettingType[ListingSettingType["EnableApplyNowUrl"] = 5] = "EnableApplyNowUrl";
    ListingSettingType[ListingSettingType["EnableRentByLeaseTerm"] = 6] = "EnableRentByLeaseTerm";
    ListingSettingType[ListingSettingType["IncomeRestrictionPercents"] = 7] = "IncomeRestrictionPercents";
})(ListingSettingType || (ListingSettingType = {}));
